// Below are built-in components that are available in the app, it's recommended to keep them as is

import { BYOCServerWrapper, NextjsContentSdkComponent, FEaaSServerWrapper } from '@sitecore-content-sdk/nextjs';
import { Form } from '@sitecore-content-sdk/nextjs';

// end of built-in components
import * as WelcomeModule from 'src/components/welcome-module/WelcomeModule';
import * as VisualDivider from 'src/components/visual-divider/VisualDivider';
import * as VideoComponent from 'src/components/video-component/VideoComponent';
import * as Title from 'src/components/sxa/title/Title';
import * as RowSplitter from 'src/components/sxa/row-splitter/RowSplitter';
import * as RichText from 'src/components/sxa/rich-text/RichText';
import * as Promo from 'src/components/sxa/promo/Promo';
import * as PageContent from 'src/components/sxa/page-content/PageContent';
import * as Navigation from 'src/components/sxa/navigation/Navigation';
import * as LinkList from 'src/components/sxa/link-list/LinkList';
import * as Image from 'src/components/sxa/image/Image';
import * as Container from 'src/components/sxa/container/Container';
import * as TwoColumnSplitter from 'src/components/sxa/column-splitter/TwoColumnSplitter';
import * as ThreeColumnSplitter from 'src/components/sxa/column-splitter/ThreeColumnSplitter';
import * as FourColumnSplitter from 'src/components/sxa/column-splitter/FourColumnSplitter';
import * as FiveColumnSplitter from 'src/components/sxa/column-splitter/FiveColumnSplitter';
import * as ColumnSplitter from 'src/components/sxa/column-splitter/ColumnSplitter';
import * as SSOSignIn from 'src/components/sso-sign-in/SSOSignIn';
import * as SitemapNavigation from 'src/components/sitemap-navigation/SitemapNavigation';
import * as SectionHero from 'src/components/section-hero/SectionHero';
import * as SectionHeader from 'src/components/section-header/SectionHeader';
import * as ProgressiveProfilePopup from 'src/components/progressive-profile-popup/ProgressiveProfilePopup';
import * as PersonalizationContentZone from 'src/components/personalization-content-zone/PersonalizationContentZone';
import * as PartialDesignDynamicPlaceholder from 'src/components/partial-design-dynamic-placeholder/PartialDesignDynamicPlaceholder';
import * as MegaMenu from 'src/components/mega-menu/MegaMenu';
import * as LanguagePicker from 'src/components/language-picker/LanguagePicker';
import * as HorizontalNavigation from 'src/components/horizontal-navigation/HorizontalNavigation';
import * as HeroCarousel from 'src/components/hero-carousel/HeroCarousel';
import * as ContactCard from 'src/components/contact-card/ContactCard';
import * as StoriesDetails from 'src/components/ch/stories-details/StoriesDetails';
import * as NewsDetails from 'src/components/ch/news-details/NewsDetails';
import * as LocationDetails from 'src/components/ch/location-details/LocationDetails';
import * as EventDetails from 'src/components/ch/event-details/EventDetails';
import * as ArticleDetails from 'src/components/ch/article-details/ArticleDetails';
import * as CardStack from 'src/components/card-stack/CardStack';
import * as BrandPillar from 'src/components/brand-pillar/BrandPillar';
import * as TVD from 'src/components/TVD/TVD';
import * as Section from 'src/components/Section/Section';
import * as SearchSummary from 'src/components/Search/search-summary/SearchSummary';
import * as SearchSortFacet from 'src/components/Search/search-sort-facet/SearchSortFacet';
import * as SearchSort from 'src/components/Search/search-sort/SearchSort';
import * as useSearchResultsState from 'src/components/Search/search-results/useSearchResultsState';
import * as SearchResultsShell from 'src/components/Search/search-results/SearchResultsShell';
import * as SearchResults from 'src/components/Search/search-results/SearchResults';
import * as CustomNoResult from 'src/components/Search/search-results/CustomNoResult';
import * as SearchPager from 'src/components/Search/search-pager/SearchPager';
import * as useCatalogFilter from 'src/components/Search/search-filter/useCatalogFilter';
import * as SearchFilterSolutionCatalog from 'src/components/Search/search-filter/SearchFilterSolutionCatalog';
import * as SearchFilterOfferingCatalog from 'src/components/Search/search-filter/SearchFilterOfferingCatalog';
import * as SearchFilter from 'src/components/Search/search-filter/SearchFilter';
import * as CatalogEditingHint from 'src/components/Search/search-filter/CatalogEditingHint';
import * as SearchFacet from 'src/components/Search/search-facet/SearchFacet';
import * as SearchContainer from 'src/components/Search/search-container/SearchContainer';
import * as SearchBreadbox from 'src/components/Search/search-breadbox/SearchBreadbox';
import * as SearchBox from 'src/components/Search/search-box/SearchBox';
import * as ContextualCardCarousel from 'src/components/Search/card-carousel/ContextualCardCarousel';
import * as CardCarouselclient from 'src/components/Search/card-carousel/CardCarousel.client';
import * as CardCarousel from 'src/components/Search/card-carousel/CardCarousel';
import * as SalesforceInteractionsScripts from 'src/components/Salesforce/SalesforceInteractionsScripts';
import * as Placeholder from 'src/components/Placeholder/Placeholder';
import * as ModalDialog from 'src/components/Modal/ModalDialog';
import * as Modal from 'src/components/Modal/Modal';
import * as SkipLink from 'src/components/Metadata/skip-link/SkipLink';
import * as XmcCoveoMetadata from 'src/components/Metadata/coveo-metadata/XmcCoveoMetadata';
import * as CoveoMetadata from 'src/components/Metadata/coveo-metadata/CoveoMetadata';
import * as ChCoveoMetadata from 'src/components/Metadata/coveo-metadata/ChCoveoMetadata';
import * as CanonicalUrlWithSlug from 'src/components/Metadata/canonical-url/CanonicalUrlWithSlug';
import * as CanonicalUrl from 'src/components/Metadata/canonical-url/CanonicalUrl';
import * as SeoMetadata from 'src/components/Metadata/Seo/SeoMetadata';
import * as ChSeoMetadata from 'src/components/Metadata/Seo/ChSeoMetadata';
import * as Script from 'src/components/Metadata/Script/Script';
import * as OgpMetadata from 'src/components/Metadata/Ogp/OgpMetadata';
import * as ChOgpMetadata from 'src/components/Metadata/Ogp/ChOgpMetadata';
import * as Gtm from 'src/components/Metadata/Gtm/Gtm';
import * as Favicon from 'src/components/Metadata/Favicon/Favicon';
import * as CustomMetadata from 'src/components/Metadata/Custom/CustomMetadata';
import * as Link from 'src/components/Link/Link';
import * as Iframe from 'src/components/Iframe/Iframe';
import * as FormReferringUrl from 'src/components/Forms/FormReferringUrl';
import * as Copyright from 'src/components/Copyright/Copyright';
import * as ChatbotScripts from 'src/components/Chatbot/ChatbotScripts';
import * as CardVideoModal from 'src/components/Card/CardVideoModal';
import * as Card from 'src/components/Card/Card';
import * as AccordionItem from 'src/components/Accordion/AccordionItem';
import * as Accordion from 'src/components/Accordion/Accordion';

export const componentMap = new Map<string, NextjsContentSdkComponent>([
  ['BYOCWrapper', BYOCServerWrapper],
  ['FEaaSWrapper', FEaaSServerWrapper],
  ['Form', { ...Form, componentType: 'client' }],
  ['WelcomeModule', { ...WelcomeModule }],
  ['VisualDivider', { ...VisualDivider }],
  ['VideoComponent', { ...VideoComponent, componentType: 'client' }],
  ['Title', { ...Title }],
  ['RowSplitter', { ...RowSplitter, componentType: 'client' }],
  ['RichText', { ...RichText, componentType: 'client' }],
  ['Promo', { ...Promo }],
  ['PageContent', { ...PageContent }],
  ['Navigation', { ...Navigation, componentType: 'client' }],
  ['LinkList', { ...LinkList, componentType: 'client' }],
  ['Image', { ...Image, componentType: 'client' }],
  ['Container', { ...Container }],
  ['TwoColumnSplitter', { ...TwoColumnSplitter, componentType: 'client' }],
  ['ThreeColumnSplitter', { ...ThreeColumnSplitter, componentType: 'client' }],
  ['FourColumnSplitter', { ...FourColumnSplitter, componentType: 'client' }],
  ['FiveColumnSplitter', { ...FiveColumnSplitter, componentType: 'client' }],
  ['ColumnSplitter', { ...ColumnSplitter, componentType: 'client' }],
  ['SSOSignIn', { ...SSOSignIn, componentType: 'client' }],
  ['SitemapNavigation', { ...SitemapNavigation }],
  ['SectionHero', { ...SectionHero }],
  ['SectionHeader', { ...SectionHeader, componentType: 'client' }],
  ['ProgressiveProfilePopup', { ...ProgressiveProfilePopup, componentType: 'client' }],
  ['PersonalizationContentZone', { ...PersonalizationContentZone }],
  ['PartialDesignDynamicPlaceholder', { ...PartialDesignDynamicPlaceholder }],
  ['MegaMenu', { ...MegaMenu, componentType: 'client' }],
  ['LanguagePicker', { ...LanguagePicker, componentType: 'client' }],
  ['HorizontalNavigation', { ...HorizontalNavigation }],
  ['HeroCarousel', { ...HeroCarousel, componentType: 'client' }],
  ['ContactCard', { ...ContactCard, componentType: 'client' }],
  ['StoriesDetails', { ...StoriesDetails, componentType: 'client' }],
  ['NewsDetails', { ...NewsDetails, componentType: 'client' }],
  ['LocationDetails', { ...LocationDetails, componentType: 'client' }],
  ['EventDetails', { ...EventDetails, componentType: 'client' }],
  ['ArticleDetails', { ...ArticleDetails, componentType: 'client' }],
  ['CardStack', { ...CardStack, componentType: 'client' }],
  ['BrandPillar', { ...BrandPillar }],
  ['TVD', { ...TVD }],
  ['Section', { ...Section }],
  ['SearchSummary', { ...SearchSummary, componentType: 'client' }],
  ['SearchSortFacet', { ...SearchSortFacet, componentType: 'client' }],
  ['SearchSort', { ...SearchSort, componentType: 'client' }],
  ['useSearchResultsState', { ...useSearchResultsState, componentType: 'client' }],
  ['SearchResultsShell', { ...SearchResultsShell, componentType: 'client' }],
  ['SearchResults', { ...SearchResults, componentType: 'client' }],
  ['CustomNoResult', { ...CustomNoResult, componentType: 'client' }],
  ['SearchPager', { ...SearchPager, componentType: 'client' }],
  ['useCatalogFilter', { ...useCatalogFilter, componentType: 'client' }],
  ['SearchFilterSolutionCatalog', { ...SearchFilterSolutionCatalog, componentType: 'client' }],
  ['SearchFilterOfferingCatalog', { ...SearchFilterOfferingCatalog, componentType: 'client' }],
  ['SearchFilter', { ...SearchFilter, componentType: 'client' }],
  ['CatalogEditingHint', { ...CatalogEditingHint }],
  ['SearchFacet', { ...SearchFacet, componentType: 'client' }],
  ['SearchContainer', { ...SearchContainer, componentType: 'client' }],
  ['SearchBreadbox', { ...SearchBreadbox, componentType: 'client' }],
  ['SearchBox', { ...SearchBox, componentType: 'client' }],
  ['ContextualCardCarousel', { ...ContextualCardCarousel, componentType: 'client' }],
  ['CardCarousel', { ...CardCarouselclient, ...CardCarousel, componentType: 'client' }],
  ['SalesforceInteractionsScripts', { ...SalesforceInteractionsScripts }],
  ['Placeholder', { ...Placeholder }],
  ['ModalDialog', { ...ModalDialog, componentType: 'client' }],
  ['Modal', { ...Modal }],
  ['SkipLink', { ...SkipLink }],
  ['XmcCoveoMetadata', { ...XmcCoveoMetadata }],
  ['CoveoMetadata', { ...CoveoMetadata }],
  ['ChCoveoMetadata', { ...ChCoveoMetadata }],
  ['CanonicalUrlWithSlug', { ...CanonicalUrlWithSlug }],
  ['CanonicalUrl', { ...CanonicalUrl }],
  ['SeoMetadata', { ...SeoMetadata }],
  ['ChSeoMetadata', { ...ChSeoMetadata }],
  ['Script', { ...Script, componentType: 'client' }],
  ['OgpMetadata', { ...OgpMetadata }],
  ['ChOgpMetadata', { ...ChOgpMetadata }],
  ['Gtm', { ...Gtm, componentType: 'client' }],
  ['Favicon', { ...Favicon }],
  ['CustomMetadata', { ...CustomMetadata }],
  ['Link', { ...Link, componentType: 'client' }],
  ['Iframe', { ...Iframe, componentType: 'client' }],
  ['FormReferringUrl', { ...FormReferringUrl, componentType: 'client' }],
  ['Copyright', { ...Copyright }],
  ['ChatbotScripts', { ...ChatbotScripts, componentType: 'client' }],
  ['CardVideoModal', { ...CardVideoModal, componentType: 'client' }],
  ['Card', { ...Card, componentType: 'client' }],
  ['AccordionItem', { ...AccordionItem, componentType: 'client' }],
  ['Accordion', { ...Accordion, componentType: 'client' }],
]);

export default componentMap;
